import styled from 'styled-components';

import { Button } from '@dreryk/react-components';

export const StyledConfidentialAccessButton = styled(Button)`
   width: 100%;

   > span > div {
      justify-content: center;
   }
`;
